export const menuItems = [
  {
    id: 25,
    label: "Dashboard",
    link: "/",
    parentId: 1,
  },

  {
    id: 1,
    label: "Master Asesmen",
    subItems: [
      {
        id: 2,
        label: "Jabatan Asesmen (KKJ)",
        link: "/master-asesmen/jabatan-kompetensi",
        parentId: 1,
      },
      {
        id: 3,
        label: "Kategori Studi Kasus",
        link: "/master-asesmen/kategori-studi-kasus",
        parentId: 1,
      },
      {
        id: 4,
        label: "Tools Asesmen",
        link: "/master-asesmen/tools-asesmen",
        parentId: 1,
      },
      {
        id: 30,
        label: "Penyusun Soal",
        link: "/master-asesmen/penyusun-soal",
        parentId: 1,
      },
      {
        id: 5,
        label: "Konfigurasi Timer",
        link: "/master/timer",
        parentId: 1,
      },
      {
        id: 6,
        label: "Treshold Nilai",
        link: "/master/treshold-nilai",
        parentId: 1,
      },
      {
        id: 23,
        label: "Treshold Analisa Soal",
        link: "/master/treshold-analisa-soal",
        parentId: 1,
      },
      {
        id: 18,
        label: "Pelaksanaan",
        link: "/master/pelaksanaan",
        parentId: 1,
      },
      {
        id: 22,
        label: "Kategori Klasifikasi",
        link: "/master/kategori-klasifikasi",
        parentId: 1,
      },

      {
        id: 55,
        label: "Proctor Config",
        link: "/master/proctor-config",
        parentId: 1,
        noCheck: true,
      },
    ],
  },
  {
    id: 40,
    label: "Master Survei",
    subItems: [
      {
        id: 41,
        label: "Master Pertanyaan Survei",
        link: "/master/pertanyaan",
        parentId: 40,
      },
      {
        id: 42,
        label: "Master Jawaban Survei",
        link: "/master/jawaban",
        parentId: 40,
      },
      {
        id: 44,
        label: "Master Kategori Survei",
        link: "/master/kategori-survei",
        parentId: 40,
      },
      {
        id: 45,
        label: "Master Dimensi Survei",
        link: "/master/dimensi-survei",
        parentId: 40,
      },
    ],
  },
  {
    id: 46,
    label: "Master Pegawai",
    subItems: [
      {
        id: 47,
        label: "Pegawai Internal",
        link: "/master/pegawai-internal",
        parentId: 46,
      },
      {
        id: 48,
        label: "Pegawai Eksternal",
        link: "/master/pegawai-eksternal",
        parentId: 46,
      },
    ],
  },
  {
    id: 49,
    label: "Master Verifikasi",
    subItems: [
      {
        id: 50,
        label: "Asesmen Objektif",
        link: "/master-verifikasi/asesmen-objektif",
        noCheck: true,
        parentId: 49,
      },
      {
        id: 51,
        label: "Taksonomi Bloom",
        link: "/master-verifikasi/taksonomi",
        noCheck: true,
        parentId: 49,
      },
      {
        id: 52,
        label: "Judul Diklat",
        link: "/master-verifikasi/diklat",
        noCheck: true,
        parentId: 49,
      },
      {
        id: 53,
        label: "Tindakan Soal",
        link: "/master-verifikasi/tindakan-soal",
        noCheck: true,
        parentId: 49,
      },
      {
        id: 54,
        label: "Referensi",
        link: "/master-verifikasi/referensi",
        noCheck: true,
        parentId: 49,
      },
      {
        id: 55,
        label: "Validator",
        link: "/master-verifikasi/validator",
        noCheck: true,
        parentId: 49,
      },
      {
        id: 56,
        label: "Level Kompetensi",
        link: "/master-verifikasi/level-kompetensi",
        noCheck: true,
        parentId: 49,
      },
      {
        id: 57,
        label: "Kompetensi",
        link: "/master-verifikasi/kompetensi",
        noCheck: true,
        parentId: 49,
      },
      {
        id: 58,
        label: "Kompetensi Validator",
        link: "/verifikasi/kompetensi-validator",
        noCheck: true,
        parentId: 49,
      },
      {
        id: 59,
        label: "Kompetensi Level",
        link: "/master-verifikasi/kompetensi-level",
        noCheck: true,
        parentId: 49,
      },
    ],
  },
  {
    id: 24,
    label: "Master Kompetensi",
    link: "/master/kompetensi",
    parentId: 1,
  },
  {
    id: 10,
    label: "Jadwal Pelaksanaan",
    link: "/master-penjadwalan/jadwal-pelaksanaan",
    parentId: 1,
  },
  {
    id: 15,
    label: "Report Asesmen",
    subItems: [
      {
        id: 16,
        label: "Report Jadwal",
        link: "/report-jadwal",
        parentId: 1,
      },
      {
        id: 11,
        label: "Report Nilai Kompetensi",
        link: "/report-nilai-kompetensi",
        parentId: 1,
      },
      {
        id: 11,
        label: "Report Nilai Jabatan",
        link: "/report-nilai-jabatan",
        parentId: 1,
      },
      {
        id: 12,
        label: "Report Hasil",
        link: "/report-hasil",
        parentId: 1,
      },
      {
        id: 32,
        label: "Report Pembinaan Grade",
        link: "/report-pembinaan-grade",
        parentId: 15,
      },
      {
        id: 29,
        label: "Report Analisa Soal",
        link: "/report-analisa-soal",
        parentId: 1,
      },
      {
        id: 26,
        label: "Report Success Profile",
        link: "/report-success-profile",
        parentId: 1,
      },
      {
        id: 28,
        label: "Report Tools Asesmen",
        link: "/report-tools-asesmen",
        parentId: 1,
      },
      {
        id: 43,
        label: "Report Survei Peserta",
        link: "/report-survei-peserta",
        parentId: 1,
      },
      {
        id: 55,
        label: "Report Proctor Peserta",
        link: "/report-proctor-peserta",
        parentId: 1,
        noCheck: true,
      },
    ],
  },
  {
    id: 13,
    label: "Log Peserta",
    link: "/log-peserta",
    parentId: 1,
  },
  {
    id: 14,
    label: "File Manager",
    link: "/file-manager",
    parentId: 1,
  },
  // {
  //   id: 31,
  //   label: "Informasi Ujian Demo",
  //   link: "/info-ujian-demo",
  //   parentId: 1,
  // },
  {
    id: 14,
    label: "Informasi Ujian",
    link: "/info-ujian",
    parentId: 1,
  },
  {
    id: 19,
    label: "Manajemen Hak Akses",
    subItems: [
      {
        id: 20,
        label: "Role User",
        link: "/master/role",
        parentId: 19,
      },
      {
        id: 21,
        label: "User",
        link: "/master/user",
        parentId: 19,
      },
    ],
  },
  {
    id: 33,
    label: "Audit Log",
    subItems: [
      {
        id: 34,
        label: "Log Aktivitas",
        link: "/log-activity",
        parentId: 33,
      },
      {
        id: 35,
        label: "Log Aksi",
        link: "/log-action",
        parentId: 33,
      },
      {
        id: 36,
        label: "Log Aktivitas Peserta",
        link: "/log-activity-peserta",
        parentId: 33,
      },
    ],
  },
  {
    id: 900,
    label: "Master Dashboard",
    subItems: [
      {
        id: 901,
        label: "Config",
        link: "/master/dashboard",
        noCheck: true,
        parentId: 900,
      },
    ],
  },
];
